import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Menu, Button, Image, Grid, Segment } from "semantic-ui-react";
import GenericForm from "./GenericForm";

@observer
class ExpandedForm extends Component {
  render() {
    const { model, validation, serverValidation, bindInput, setProperty, onCancel, onSubmit, t } = this.props;

    return (
      <div className="expanded-form">
        <Menu className="media-edit-header">
          <Menu.Menu position="right">
            <Menu.Item>
              <Button secondary onClick={onCancel}>
                Cancel
              </Button>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Segment>
          <Grid columns={1}>
            <Grid.Row>
              <Grid.Column>
                <Image src={model.imagePathWebLarge} fluid rounded bordered />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <GenericForm
                  model={model}
                  t={t}
                  validation={validation}
                  serverValidation={serverValidation}
                  bindInput={bindInput}
                  setProperty={setProperty}
                  onSubmit={onSubmit}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

ExpandedForm.propTypes = {
  model: PropTypes.shape({
    className: PropTypes.oneOf(["Photo", "VideoClip", "VirtualTour"]).isRequired,
    imagePathWebLarge: PropTypes.string.isRequired,
    name: PropTypes.string,
    description: PropTypes.string,
    includeIn: PropTypes.string,
    duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    displayDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    brandingMode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isNavigationLayer: PropTypes.bool,
    panRight: PropTypes.bool,
  }),
  // the return value of ValidateSchema.getValidationErrors()
  validation: PropTypes.shape({
    isValid: PropTypes.bool,
    fields: PropTypes.shape({
      name: PropTypes.shape({
        isValid: PropTypes.bool,
        errors: PropTypes.arrayOf(PropTypes.string),
      }),
      description: PropTypes.shape({
        isValid: PropTypes.bool,
        errors: PropTypes.arrayOf(PropTypes.string),
      }),
      duration: PropTypes.shape({
        isValid: PropTypes.bool,
        errors: PropTypes.arrayOf(PropTypes.string),
      }),
    }).isRequired,
  }).isRequired,
  serverValidation: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    duration: PropTypes.string,
  }).isRequired,
  setProperty: PropTypes.func.isRequired,
  bindInput: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ExpandedForm);
